import { defineTheme } from '../utils'

export const next = defineTheme({
  languageButton: {
    base: 'rounded-sm border border-primary p-2.5 text-sm',
  },
  menuCategory: {
    title: 'font-heading text-2xl font-extrabold',
    description: 'font-heading text-xl font-extrabold text-secondary',
  },
  menuItem: {
    dinner: {
      base: 'grid grid-cols-[1fr_auto] gap-x-2',
      title: 'col-start-1 row-start-1 font-bold',
      description: 'col-start-1 row-start-2 mt-1 text-sm',
      priceList: 'col-start-2 row-span-3 row-start-1 self-start text-right',
      priceItem: 'flex justify-end gap-1 text-sm',
      icons: 'col-start-1 row-start-3 mt-1',
      label: 'col-span-2 row-start-4 mt-1 bg-white p-2 text-xs text-gray-700',
    },
    drinks: {
      base: 'grid grid-cols-[1fr_auto] gap-x-2',
      title: 'col-start-1 row-start-1 font-bold',
      description: 'col-start-1 row-start-2 mt-1 text-sm',
      priceList: 'col-start-2 row-span-3 row-start-1 self-start text-right',
      priceItem: 'flex justify-end gap-1 text-sm',
      icons: 'col-start-1 row-start-3 mt-1',
      label: 'col-span-2 row-start-4 mt-1 bg-white p-2 text-xs text-gray-700',
    },
  },
  menuSubCategory: {
    base: 'grid gap-4',
    title: '-mb-3 font-heading text-base font-semibold text-secondary underline',
    description: 'mt-3 text-sm text-secondary',
  },
  menuTextBlock: {
    base: 'block bg-secondary p-6 text-white',
    title: 'font-heading text-base font-extrabold',
    description: 'text-sm',
  },
  menuTitleBlock: {
    title: 'font-heading text-3xl font-extrabold text-secondary uppercase md:text-4xl',
  },
  page: {
    heading: 'font-heading text-6xl font-bold text-secondary uppercase',
    menuHeading: 'mb-4 font-heading text-3xl font-bold text-secondary uppercase md:text-6xl',
    menuDescription: 'mb-8 block bg-secondary p-6 text-sm text-white',
  },
  themeLogo: {
    image: 'h-38 w-60 bg-[url(/images/logos/next.svg)] bg-contain bg-center bg-no-repeat',
  },
  filterBar: {
    bar: 'bg-secondary text-white',
    checkbox: 'accent-secondary',
    closeButton: 'bg-secondary text-white hover:bg-secondary/80',
  },
})
